<!-- ============================================================================
     AI-JAVADOC: DcPageObjectComponent Template
     Component: DcPageObjectComponent
     Module: DC (Document Classification)
     Description: Object detail view for dc.DcPage with three navigation sections:
                  - Inhalte:  DcPageContent table widget filtered by this page
                  - Objekte:  DcPageObject  table widget filtered by this page
                  - Begriffe: DcPageTerm    table widget filtered by this page
     ============================================================================ -->

@if (initialized && dto) {

    <!-- ==================== Section: Inhalte ==================== -->
    @if (activeNavigationItems?.action == 'contents') {
        <div class="p-3">
            @if (contentsWidget) {
                <mvs-widget [widgetData]="contentsWidget"></mvs-widget>
            }
        </div>
    }

    <!-- ==================== Section: Objekte ==================== -->
    @if (activeNavigationItems?.action == 'objects') {
        <div class="p-3">
            @if (objectsWidget) {
                <mvs-widget [widgetData]="objectsWidget"></mvs-widget>
            }
        </div>
    }

    <!-- ==================== Section: Begriffe ==================== -->
    @if (activeNavigationItems?.action == 'terms') {
        <div class="p-3">
            @if (termsWidget) {
                <mvs-widget [widgetData]="termsWidget"></mvs-widget>
            }
        </div>
    }

}
